import React from 'react';
import ReactDOM from 'react-dom';
import 'react-app-polyfill/ie11';
import '@babel/polyfill';
import './index.css';
// import * as serviceWorker from './serviceWorker';
import { FrameworkComponent } from './view/framework/FrameworkComponent';
import { Router } from 'react-router-dom';
import { createHashHistory, createBrowserHistory } from 'history';
import MainComponent from './view/main/MainComponent';
import TestMainComponent from './test/view/test_main/TestMainComponent';

// const history = createHashHistory();
const history = createBrowserHistory();

// 20210203 DE-1128 START
const utagScript = document.createElement('script');
utagScript.setAttribute('src', process.env.UTAG_SRC_URL);
utagScript.setAttribute('type', 'text/javascript');
document.head.appendChild(utagScript);
// 20210203 DE-1128 END

ReactDOM.render(
	<React.StrictMode>
		<Router history={history}>
			<FrameworkComponent />
			<MainComponent />
			{/* <TestMainComponent /> */}
		</Router>
	</React.StrictMode>,
	document.getElementById('root')
);
	
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
